module.exports = __webpack_public_path__ + "static/media/google-play-badge.928ad72a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/footer/google-play-badge.svg
// module id = 1208
// module chunks = 40